export class NoAnswerItem extends Error {
  constructor() {
    super(`NoAnswerItem`);
    this.name = 'NoAnswerItem';

    Error.captureStackTrace(this, NoAnswerItem);
  }
}
